import { DEFAULT_CHAT_CONFIG, DEFAULT_SYSTEM_MESSAGE } from '@config/chat/ChatConfig';
import { ChatInterface } from '@type/chat';
import { createMessage } from '@utils/chatNavigation';
import { generateUUID } from '@utils/uuid';

// Chat Factory
export const generateDefaultChat = (title?: string, folder?: string, systemMessage?: string): ChatInterface => {
  return {
    id: generateUUID(),
    title: title || 'New Chat',
    messages: systemMessage 
      ? [createMessage('system', systemMessage)] 
      : [],
    config: {
      provider: DEFAULT_CHAT_CONFIG.provider,
      modelConfig: {
        ...DEFAULT_CHAT_CONFIG.modelConfig,
      },
    },
    titleSet: false,
    ...(folder ? { folder } : {}),
    timestamp: Date.now()
  };
};


// Default chats
export const DEFAULT_CHATS: ChatInterface[] = [
  generateDefaultChat('Project Planning Assistant', 'work-folder', DEFAULT_SYSTEM_MESSAGE),
  generateDefaultChat('Study Notes & Explanations', 'learning-folder', DEFAULT_SYSTEM_MESSAGE),
];

// Re-export configuration
export { 
  DEFAULT_CHAT_CONFIG,
  DEFAULT_SYSTEM_MESSAGE 
} from '@config/chat/ChatConfig';
